import React from "react";
import {FIELD_TYPE, TT_THUOC, TT_VTYT} from "types/enums";
import {
  formatDateToString,
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeToFixed,
} from "helper/common";
import {DataFormField} from "types/models/input-field-type";
import {Form, Tooltip, Typography} from "antd";
import StatusCard from "pages/Medicines/StatusCard/StatusCard";

const {INPUT, CURRENCY, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER, DATE_DISABLE} =
  FIELD_TYPE;

const allColumns: any[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    fixed: "left",
    width: 50,
    align: "center",
  },
  {
    title: "Mã VTYT",
    key: "vtytid",
    show: true,
    dataIndex: "vtytid",
    width: 80,
    align: "left",
  },
  {
    title: "Số lô",
    key: "soLo",
    show: true,
    width: 150,
    dataIndex: "soLo",
    render: text => (
      <Tooltip title={text} placement="top" arrow={false}>
        <Typography.Text ellipsis={true}>{text}</Typography.Text>
      </Tooltip>
    ),
    align: "left",
  },
  {
    title: "Mã hàng",
    key: "maHang",
    show: false,
    width: 80,
    dataIndex: "maHang",
    align: "left",
  },
  {
    title: "Tên vật tư",
    key: "tenTheoThuongMai",
    show: true,
    width: 150,
    dataIndex: "tenTheoThuongMai",
  },
  {
    title: "Quy cách",
    key: "quyCachName",
    show: false,
    dataIndex: "quyCachName",
    width: 80,
  },
  {
    title: "Đơn vị tính",
    key: "donViTinhName",
    show: true,
    align: "center",
    dataIndex: "donViTinhName",
    width: 90,
  },
  {
    title: "Nhóm VTYT",
    key: "nhomVTYTName",
    show: false,
    dataIndex: "nhomVTYTName",
    width: 90,
  },

  {
    title: "Kho vật tư",
    key: "storeName",
    show: false,
    dataIndex: "storeName",
    width: 120,
  },
  {
    title: "Tình trạng",
    key: "tinhTrang",
    show: true,
    dataIndex: "tinhTrang",
    width: 90,
    align: "center",
    render(value, record, index) {
      let text = "";
      if (value == "BT") {
        text = "Bình thường";
      }
      if (value == "GHH") {
        text = "Gần hết hạn";
      }
      if (value == "QH") {
        text = "Quá hạn";
      }
      if (value == "HH") {
        text = "Hết hạn";
      }
      if (value == "GH" || text == "Gần hết hàng") {
        text = "Gần hết hàng";
      }
      return <StatusCard status={text}></StatusCard>;
    },
  },
  {
    title: "Số lượng tồn",
    key: "soLuongTon",
    width: 80,
    show: true,
    dataIndex: "soLuongTon",
    align: "right",
  },
  {
    title: "Số đã xuất",
    key: "soLuongDaXuat",
    show: true,
    dataIndex: "soLuongDaXuat",
    width: 80,
    align: "right",
  },
  {
    title: "Số lượng nhập",
    key: "soLuongNhap",
    width: 80,
    show: true,
    dataIndex: "soLuongNhap",
    align: "right",
  },
  {
    title: "Số lượng hết hạn",
    key: "soLuongHetHan",
    width: 80,
    show: false,
    dataIndex: "soLuongHetHan",
    align: "right",
  },
  {
    title: "Số lượng trả NCC",
    key: "soLuongTraNCC",
    width: 80,
    show: true,
    dataIndex: "soLuongTraNCC",
    align: "right",
  },
  {
    title: "SL xuất dự kiến",
    key: "xuatDuKien",
    show: true,
    width: 80,
    dataIndex: "xuatDuKien",
    align: "right",
    editable: true,
  },
  {
    title: "SL dự trù",
    key: "soLuongDuTru",
    show: true,
    dataIndex: "soLuongDuTru",
    align: "right",
    width: 80,
  },

  {
    title: "Ngày nhập",
    key: "createDate",
    show: true,
    dataIndex: "createDate",
    width: 90,
    align: "center",
    render(value) {
      return <>{value ? formatDateToString(value) : ""}</>;
    },
  },
  {
    title: "Ngày sản xuất",
    key: "ngaySanXuat",
    show: false,
    width: 90,
    align: "center",
    dataIndex: "ngaySanXuat",
    render(value) {
      return <>{value ? formatDateToString(value) : ""}</>;
    },
  },
  {
    title: "Ngày hết hạn",
    key: "ngayHetHan",
    show: true,
    align: "center",
    dataIndex: "ngayHetHan",
    width: 90,
    render(value) {
      return <>{value ? formatDateToString(value) : ""}</>;
    },
  },
  {
    title: "Ngày thông báo hết hạn",
    key: "ngayThongBaoHetHan",
    show: true,
    align: "center",
    dataIndex: "ngayThongBaoHetHan",
    width: 90,
    render(value) {
      return <>{value ? formatDateToString(value) : ""}</>;
    },
  },
  {
    type: CURRENCY,
    title: "Đơn giá nhập",
    key: "donGiaNhap",
    show: true,
    dataIndex: "donGiaNhap",
    width: 90,
    align: "right",
    editable: true,
    render(value, record, index) {
      return <>{formatToCurrencyTypeToFixed(value, 2)}</>;
    },
  },
  {
    type: CURRENCY,
    title: "Đơn giá xuất",
    key: "donGiaXuat",
    width: 90,
    show: true,
    align: "right",
    dataIndex: "donGiaXuat",
    editable: true,
    render(value, record, index) {
      return <>{formatToCurrencyTypeToFixed(value, 2)}</>;
    },
  },
  {
    title: "VAT(%)",
    key: "vat",
    width: 60,
    align: "right",
    show: false,
    dataIndex: "vat",
  },

  {
    title: "Giá trị BH chi trả",
    key: "giaTriBHChiTra",
    align: "right",
    width: 90,
    show: false,
    dataIndex: "giaTriBHChiTra",
    render(value, record, index) {
      return <>{formatToCurrencyTypeFloor(value)}</>;
    },
  },
  {
    title: "Mã BH",
    key: "maBaoHiem",
    width: 150,
    show: false,
    align: "left",
    dataIndex: "maBaoHiem",
  },
  {
    title: "Tên theo BH",
    key: "tenTheoBaoHiem",
    width: 150,
    show: false,
    dataIndex: "tenTheoBaoHiem",
  },
  {
    title: "Hãng sản xuất",
    key: "hangSanXuatName",
    width: 150,
    show: false,
    dataIndex: "hangSanXuatName",
  },
  {
    title: "Nước sản xuất",
    key: "nuocSanXuatName",
    width: 90,
    show: false,
    dataIndex: "nuocSanXuatName",
  },
  {
    title: "Nhà cung cấp",
    key: "nhaCungCapName",
    width: 150,
    show: false,
    dataIndex: "nhaCungCapName",
  },
  {
    title: "Số thầu",
    key: "soThau",
    show: true,
    dataIndex: "soThau",
    align: "center",
    width: 140,
    render: (value, record, index) => {
      return <>{record?.quyetDinhThau?.bidCode}</>;
    },
  },
  {
    title: "Quyết định thầu",
    key: "quyetDinhThau",
    show: true,
    dataIndex: "quyetDinhThau",
    align: "center",
    width: 140,
    render: (value, record, index) => {
      return <>{record?.quyetDinhThau?.bidDecision}</>;
    },
  },
  {
    title: "Số lô của NCC",
    key: "soLoNCC",
    width: 150,
    align: "left",
    show: true,
    dataIndex: "soLoNCC",
  },
  {
    title: "Tên đơn vị áp KQĐT",
    key: "donViApKQDTName",
    width: 150,
    show: false,
    dataIndex: "donViApKQDTName",
  },
  {
    title: "Nhà thầu trúng thầu",
    key: "nhaThau",
    width: 150,
    show: false,
    dataIndex: "nhaThau",
  },
  {
    title: "Nhóm TCKT",
    key: "nhomTCKT",
    width: 150,
    show: false,
    dataIndex: "nhomTCKT",
  },
  {
    title: "Mô tả",
    key: "description",
    width: 150,
    show: false,
    dataIndex: "description",
    render: text => (
      <Tooltip title={text} placement="top" arrow={false}>
        <Typography.Text ellipsis={true}>{text}</Typography.Text>
      </Tooltip>
    ),
  },
  {
    type: INPUT,
    title: "Ghi chú",
    key: "note",
    width: 150,
    show: false,
    dataIndex: "note",
    render: text => (
      <Tooltip title={text} placement="top" arrow={false}>
        <Typography.Text ellipsis={true}>{text}</Typography.Text>
      </Tooltip>
    ),
    editable: true,
  },

  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 80,
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: NUMBER,
    name: "VTYTId",
    label: "Mã vật tư",
    expand: false,
  },
  {
    type: AUTO_COMPLETE,
    name: "VTYTName",
    expand: false,
    label: "Tên vật tư",
  },
  {
    type: AUTO_COMPLETE,
    name: "nhomVTYTName",
    expand: false,
    label: "Tên nhóm",
  },
  {
    type: COMBO_BOX,
    name: "storeId",
    expand: false,
    label: "Kho vật tư",
    allowClear: false,
  },
  {
    type: COMBO_BOX,
    name: "trangThai",
    expand: false,
    label: "Tình trạng hạn sử dụng",
    options: [
      {
        value: TT_VTYT.BINH_THUONG,
        label: "Bình thường",
      },
      {
        value: TT_VTYT.GAN_HET_HAN,
        label: "Gần hết hạn",
      },
      {value: TT_VTYT.HET_HAN, label: "Hết hạn"},
      {value: TT_VTYT.HET, label: "Hết"},
    ],
  },
  {
    type: DATE_DISABLE,
    name: "start",
    expand: true,
    label: "Ngày nhập từ",
  },
  {
    type: DATE_DISABLE,
    expand: true,
    name: "end",
    label: "Ngày nhập đến",
  },
  {
    type: AUTO_COMPLETE,
    expand: true,
    name: "nhaCungCapName",
    label: "Nhà cung cấp",
  },
  {
    expand: true,
    type: AUTO_COMPLETE,
    name: "hangSanXuatName",
    label: "Hãng sản xuất",
  },
  {
    expand: true,
    type: AUTO_COMPLETE,
    name: "nuocSanXuatName",
    label: "Nước sản xuất",
  },
  {
    expand: true,
    type: INPUT,
    name: "soLo",
    label: "Số lô",
  },
];

export {allColumns, itemsInputField};
